import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import Modal from 'react-bootstrap/lib/Modal';
import Button from 'react-bootstrap/lib/Button';
import DropdownButton from 'react-bootstrap/lib/DropdownButton';
import MenuItem from 'react-bootstrap/lib/MenuItem';
import Dialog from 'components/Dialog';
import * as actions from 'modules/orders';
import SelectDateDialog from 'components/SelectDateDialog';
import UpdateCustomerDialog from './UpdateCustomerDialog';
import { shopifyService } from 'services';
import { isCustomerInvoiceExcluded } from 'utils/customerInvoiceExclusions';

import moment from 'moment';

class FulfillOrderDialog extends Dialog {
    constructor(props) {
        super(props);
        this.state = {
            order: null,
            customerInvoicingDisabled: false,
            savingCustomerInvoicing: false
        }
        this.showSelectDateDialog = this.showSelectDateDialog.bind(this);
        this.showUpdateCustomerDialog = this.showUpdateCustomerDialog.bind(this);
    }

    showSelectDateDialog() {
        this.selectDateDialog.wrappedInstance.show();
    }

    showUpdateCustomerDialog() {
        this.updateCustomerDialog.wrappedInstance.show();
    }

    createInvoices(form) {
        let { dispatch, needUpgrade } = this.props;
        if (needUpgrade) {
            browserHistory.push('/billing');
        }
        else
            dispatch(actions.createInvoices({ ...this.state.selected }, this.state.filter, form.date));

        this.selectDateDialog.wrappedInstance.hide();
    }

    show(order) {

        this.setState({
            order: {
                ...order,
                shipping_address: {
                    ...order.shipping_address
                }
            },
            customerInvoicingDisabled: isCustomerInvoiceExcluded(this.props.user, order.customer && order.customer.id),
            savingCustomerInvoicing: false
        });

        super.show();
    }

    toggleCustomerInvoicing() {
        let { dispatch } = this.props;
        let order = this.state.order;
        let customerId = order && order.customer && order.customer.id;

        if (!customerId || this.state.savingCustomerInvoicing)
            return;

        let excluded = !this.state.customerInvoicingDisabled;

        this.setState({
            savingCustomerInvoicing: true
        });

        dispatch(actions.setCustomerInvoiceExclusion(customerId, excluded)).then(() => {
            this.setState({
                customerInvoicingDisabled: excluded,
                savingCustomerInvoicing: false
            });
        }).catch(() => {
            this.setState({
                savingCustomerInvoicing: false
            });
            alert('Could not update invoicing for this customer.');
        });
    }

    onOk() {
        const { onOk, order } = this.props;
        onOk(order || this.state.order);
    }
    onCancel() {
        const { onCancel, order } = this.props;
        onCancel(order || this.state.order);
    }

    downloadLabel(response) {
        var base64str = response.data;

        // decode base64 string, remove space for IE compatibility
        var binary = atob(base64str.replace(/\s/g, ''));
        var len = binary.length;
        var buffer = new ArrayBuffer(len);
        var view = new Uint8Array(buffer);
        for (var i = 0; i < len; i++) {
            view[i] = binary.charCodeAt(i);
        }
        
        // create the blob object with content-type "application/pdf"               
        var newBlob = new Blob( [view], { type: "application/pdf" });

         if (window.navigator && window.navigator.msSaveOrOpenBlob) {
             window.navigator.msSaveOrOpenBlob(newBlob, `${fileName}.${format}`);
             return;
         }
 
         // For other browsers: 
         // Create a link pointing to the ObjectURL containing the blob.
         const data = window.URL.createObjectURL(newBlob);
         var link = document.createElement('a');
         link.href = data;
         link.download = `${response.headers["file-name"]}`;
         link.setAttribute('download', `${response.headers["file-name"]}`);
         document && document.body.appendChild(link);
         link.click();
         setTimeout(function () {
             // For Firefox it is necessary to delay revoking the ObjectURL
             window.URL.revokeObjectURL(data);
         }, 100);        
    }

    gslAwb(key) {

        if (key === 'pickandreturn'){
            return shopifyService().printGlsLabel({
                pickandreturn: true,
                order: this.state.order
            })
            .then((response) => {
                this.downloadLabel(response);
            }).catch((err)=>{
                if (err && err.response && err.response.data)
                    alert(err.response.data);
            });        
        }

        if (key === 'create'){
            return shopifyService().printGlsLabel({
                create: true,
                order: this.state.order
            })
            .then((response) => {
                this.downloadLabel(response);
            }).catch((err)=>{
                if (err && err.response && err.response.data)
                    alert(err.response.data);
            });        
        }

        if (key === 'nocode'){
            return shopifyService().printGlsLabel({
                order: this.state.order
            })
            .then((response) => {
                this.downloadLabel(response);
            }).catch((err)=>{
                if (err && err.response && err.response.data)
                    alert(err.response.data);
            });
        }
    }

    downloadInvoice() {
        let { dispatch } = this.props;
        let orderId = this.state.order.id;
        let selected = {};
        selected[orderId] = true;

        dispatch(actions.exportOrders(selected, {
            what: "selected",
            format: "pdf",
            locationId : this.state.order.location_id
        }));
    }

    createInvoice(form) {
        let { dispatch, filter } = this.props;
        let orderId = this.state.order.id;
        let selected = {};
        selected[orderId] = true;
          dispatch(actions.createInvoices(selected, filter, form.date));
    
          this.selectDateDialog.wrappedInstance.hide();
          this.hide();
    }

    updateCustomer(shipping_address) {
        let {dispatch, filter} = this.props;
        let customer = this.state.order.customer || {};
        dispatch(actions.updateOrder({
            id: this.state.order.id,
            shipping_address: {
                ...shipping_address,
                first_name: customer.first_name,
                last_name: customer.last_name
            }
        }, filter));

        this.setState({
            order:{
                ...this.state.order,
                shipping_address: {
                    ...shipping_address
                }
            }
        })

        this.updateCustomerDialog.wrappedInstance.hide();
    }

    copyToClipboard(url){
        prompt('Press Ctrl + C, then Enter to copy to clipboard', `${url}`)
    }

    getLocationById(user, locationId){
        for (let i = 0; i < user.locations.length; i++){
            if (Number(user.locations[i].locationId) === Number(locationId)){
                return user.locations[i];
            }
        }
    
        return null;
    }

    getOrderLocationId(user, order){
        if(user.hasMultipleLocations){
            for (let i = 0; i < user.locations.length; i++){
                if (user.locations[i].default === true){
                    return Number(user.locations[i].locationId); //override with first default
                }
            }
        }

        return order.location_id || null;
    }

    //filter order for removed items only if in pending state or paid. if cancelled, partially refunded or voided, then retun initial items
    getOrderAvailableLineItems(order){
        
        if (order.cancelled_at !== null || order.financial_status === 'partially_refunded' || order.financial_status === 'refunded' || order.financial_status === 'voided' )
            return order.line_items;

        let refunded = [];
    
        order.refunds = order.refunds || [];
    
        for (let i = 0; i< order.refunds.length; i++){
            
            order.refunds[i].refund_line_items = order.refunds[i].refund_line_items || [];
    
            for (let j= 0; j < order.refunds[i].refund_line_items.length; j++){
                refunded.push({id: order.refunds[i].refund_line_items[j].line_item_id, quantity: order.refunds[i].refund_line_items[j].quantity});
            }
        }
    
        let getQuantity = (id) => {
            let qty = 0;
            for (let i = 0; i < refunded.length; i++){
                if (refunded[i].id === id){
                    qty += refunded[i].quantity;
                }
            }
            return qty;
        }
    
        let newLineItems = order.line_items.map(li=>{
            let discountedQty = getQuantity(li.id) || 0;
            if (li.discount_allocations){
                for (let i = 0; i < li.discount_allocations.length; i++){
                    let discountUnitPrice = Number(li.discount_allocations[i].amount) / li.quantity;
                    li.discount_allocations[i].amount = Number(li.discount_allocations[i].amount) - (discountUnitPrice * discountedQty);
                }
            }
            return {
                ...li,
                quantity: li.quantity - discountedQty
            }
        })
    
        newLineItems = newLineItems.filter(li=>li.quantity > 0);
    
        return newLineItems;
    }

    getRefundsTotal(row){
        let total = 0.0;
        row.refunds = row.refunds || [];
    
        for (let i = 0; i < row.refunds.length; i++ ){
            let refund = row.refunds[i];
            refund.refund_line_items =  refund.refund_line_items || [];
    
            for (let j = 0; j < refund.refund_line_items.length; j++){
                if (row.taxes_included)
                    total+= Number(refund.refund_line_items[j].subtotal);
                else
                    total+= Number(refund.refund_line_items[j].subtotal) +  Number(refund.refund_line_items[j].total_tax);
            }
            
            if (refund.refund_line_items.length > 0){
                for (let k = 0; k < refund.order_adjustments.length; k++){
        
                    if (row.taxes_included && refund.order_adjustments[k].kind !== "shipping_refund")
                        total-= Number(refund.order_adjustments[k].amount);
                    else
                        total-=Number(refund.order_adjustments[k].amount) +  Number(refund.order_adjustments[k].tax_amount);
                }
            }
            
        }
        return total;
    }

    render() {
        const { handleSubmit, submitting, closeButtonLabel, onOk, isValidDate, updateOrder, user } = this.props;

        const show = this.state.show;
        if (this.state.order === null)
            return (<div />);
        let customer = this.state.order.customer || {};
        let customerId = customer.id;
        let customerName = `${(customer.first_name !== null ? customer.first_name : '') || ''}
            ${(customer.last_name !== null ? customer.last_name : '') || ''}`
        let invoiceUrl = `${window ? window.location.origin: ''}/order/${user.shopify.shopName}/${customer.id},${this.state.order.id},false/pdf`;
        let stornoUrl = `${window ? window.location.origin: ''}/order/${user.shopify.shopName}/${customer.id},${this.state.order.id},true/pdf`;
        let location = this.getLocationById(user, this.getOrderLocationId(user, this.state.order));
        let glsInfo = user.gls;

        if (location && user.hasMultipleLocations){
            glsInfo = location.gls;
        }

        
        let total = this.getRefundsTotal(this.state.order);

        if (this.state.order.financial_status === 'partially_refunded' || this.state.order.financial_status === 'refunded' 
        || this.state.order.financial_status === 'voided' )
            total = 0;

        let price = parseFloat(Number(this.state.order.total_price) - total).toFixed(user.decimalPlaces);

        return (

            <Modal backdrop="static" enforceFocus={true} show={show || false} onHide={this.hide}>
                <form onSubmit={handleSubmit(onOk)}>
                    <Modal.Header closeButton>
                        <Modal.Title>Order {` ${this.state.order.name} - ${this.state.order.id}, ${this.state.order.fulfillment_status || 'unfulfilled'}, ${this.state.order.financial_status}`}</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <UpdateCustomerDialog
                            initialValues={{
                                ...this.state.order.shipping_address
                            }}
                            ref={(r) => this.updateCustomerDialog = r}
                            onOk={this.updateCustomer.bind(this)}
                        />
                        <SelectDateDialog
                            initValues={{ date: new Date().toISOString() }}
                            ref={(r) => this.selectDateDialog = r}
                            dialogTitle={'Choose a date'}
                            message={'Choose an issue date for the selected invoices'}
                            closeButtonLabel={'Cancel'}
                            submitButtonLabel={'Create Invoice'}
                            isValidDate={isValidDate}
                            defaultValue={user.currentInvoiceDate}
                            onOk={this.createInvoice.bind(this)}
                        />

                        {this.state.order.invoice_number &&
                            <div>
                                <label>Invoice: </label><button title="Copy public invoice url to clipboard" type="button" className="btn btn-sm btn-default btn-grid-sm" onClick={this.copyToClipboard.bind(this, invoiceUrl)}><i className="fa fa-link"></i></button>{` #${this.state.order.invoice_number} issued at ${moment(this.state.order.date_created).format('MM/DD/YYYY h:mm A')}`}<br /> 
                                {this.state.order.has_storno && <div><label>Storno: </label><button type="button" title="Copy public invoice url to clipboard" className="btn btn-sm btn-default btn-grid-sm" onClick={this.copyToClipboard.bind(this, stornoUrl)}><i className="fa fa-link"></i></button>{`#${this.state.order.storno_number}, issued at ${moment(this.state.order.date_storno).format('MM/DD/YYYY h:mm A')}`}</div>}
                                <br />
                            </div>
                        }
{/* <a title="View customer information" onClick={this.showUpdateCustomerDialog}><i className={updateOrder ? "fa fa-spin fa-circle-o-notch" : "fa fa-pencil"}></i></a> */}
                        <label>Customer:</label><br />Full Name: {` ${customerName}`}<br />
                        Phone: <a href={`tel:${this.state.order.shipping_address.phone || customer.phone }`}>
                        {this.state.order.shipping_address.phone || customer.phone }</a><br />
                        Email: <a href={`mailto:${this.state.order.contact_email}`}>{this.state.order.contact_email}</a><br />
                        Address: {this.state.order.shipping_address.address1} {this.state.order.shipping_address.address2} {this.state.order.shipping_address.city}<br />
                        Province: {this.state.order.shipping_address.province}<br />
                        Zip: {this.state.order.shipping_address.zip}<br />
                        Country: {this.state.order.shipping_address.country}
                        {customerId && <div style={{
                            display: 'flex',
                            alignItems: 'flex-start',
                            gap: '10px',
                            marginTop: '12px',
                            padding: '10px 12px',
                            border: '1px solid #e2e8f0',
                            borderRadius: '6px',
                            background: '#f8fafc'
                        }}>
                            <input
                                id={`invoice-customer-${customerId}`}
                                type="checkbox"
                                checked={!this.state.customerInvoicingDisabled}
                                disabled={this.state.savingCustomerInvoicing}
                                onChange={this.toggleCustomerInvoicing.bind(this)}
                                style={{ marginTop: '2px' }}
                            />
                            <div>
                                <label htmlFor={`invoice-customer-${customerId}`} style={{
                                    margin: 0,
                                    fontWeight: 500,
                                    cursor: this.state.savingCustomerInvoicing ? 'default' : 'pointer'
                                }}>
                                    Create invoices for this customer
                                </label>
                                {this.state.customerInvoicingDisabled && <div style={{
                                    marginTop: '2px',
                                    fontSize: '12px',
                                    color: '#b45309'
                                }}>
                                    Future invoices for this customer will be skipped. Existing invoices are unchanged.
                                </div>}
                            </div>
                            {this.state.savingCustomerInvoicing && <i className="fa fa-spin fa-spinner" style={{ marginLeft: 'auto' }}></i>}
                        </div>}
                        <br /><br />
                        Tracking Number: {this.state.order.fulfillments && 
                        this.state.order.fulfillments.length ? 
                        <a target="_blank" href={this.state.order.fulfillments[0].tracking_url}>{`${this.state.order.fulfillments[0].tracking_company||""} ${this.state.order.fulfillments[0].tracking_number || "-"}`}</a>
                        : ""}<br /><br />
                            
                        <label>Products: </label><br />
                        <table>
                            <thead style={{ fontWeight: 'bold' }}>
                                <tr>
                                    <td style={{ width: '350px' }}>Name</td>
                                    <td>Unit</td>
                                    <td style={{ width: '20px' }}>Quanity</td>
                                    <td>Price</td>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    this.getOrderAvailableLineItems(this.state.order).map((item) => {

                                        return (<tr>
                                            <td>{item.name}</td>
                                            <td>Qty</td>
                                            <td style={{ textAlign: "right" }}>{item.quantity}</td>
                                            <td style={{ textAlign: "right" }}>{item.price} {this.state.order.currency}</td>
                                        </tr>);
                                    })
                                }
                                {
                                    this.state.order.shipping_lines.map((item) => {

                                        return (<tr>
                                            <td>{item.title}</td>
                                            <td></td>
                                            <td style={{ textAlign: "right" }}>1</td>
                                            <td style={{ textAlign: "right" }}>{item.price} {this.state.order.currency}</td>
                                        </tr>);
                                    })
                                }

                      {parseFloat(this.state.order.total_discounts).toFixed(2) > 0.0 && <tr><td colSpan={4} style={{ textAlign: "right" }}><label>Discount: -{this.state.order.total_discounts} {this.state.order.currency} </label></td></tr>
                      }
                                <tr><td colSpan={4} style={{ textAlign: "right" }}><label>Total: {price} {this.state.order.currency} </label></td></tr>
                            </tbody>
                        </table>

                    </Modal.Body>

                    <Modal.Footer>
                        <div className="btn-group pull-left">
                        {/* 
                        Disabled for now, this feature does not make sense, nobody uses it.
                        We can implement it later if necesary.
                        {this.state.order.invoice_number &&
                            <button type="button" className="btn btn-default pull-left" onClick={this.downloadInvoice.bind(this)}><i className="fa fa-file-pdf-o"></i>{" "}Download Invoice</button>
                            // :
                            // <button type="button"className="btn btn-default pull-left" onClick={this.showSelectDateDialog}><i className="fa fa-plus"></i>{" "}Create Invoice</button>

                        } */}
                        {/* {this.state.order.fulfillment_status === null || this.state.order.fulfillment_status === "unfulfilled" &&
                            <button type="button" className="btn btn-default pull-left" onClick={this.onOk.bind(this)} disabled={submitting} bsStyle="default">Mark all products as fulfilled</button>
                        }
                        {this.state.order.fulfillment_status === 'fulfilled' || this.state.order.fulfillment_status === 'shipped' &&
                            <button type="button" className="btn btn-default pull-left" onClick={this.onCancel.bind(this)} disabled={submitting} bsStyle="default">Cancel all fulfillments</button>
                        } */}
                         {glsInfo.enabled && <DropdownButton
                            className="btn btn-default pull-left"
                            title="GLS AWB"
                            id="gls-awb"
                            onSelect={this.gslAwb.bind(this)}
                        >
                            <MenuItem eventKey="create">Create</MenuItem>
                            <MenuItem eventKey="nocode">No Code</MenuItem>
                            <MenuItem eventKey="pickandreturn">Pick and Return</MenuItem>
                        </DropdownButton>
                        }
                        </div>
                       
                        
                        <button type="button" className="btn btn-success pull-right" onClick={this.hide}>{closeButtonLabel}</button>
                    </Modal.Footer>

                </form>
            </Modal>

        );
    }
}


FulfillOrderDialog.propTypes = {
    dispatch: PropTypes.func.isRequired,
    dialogTitle: PropTypes.string.isRequired,
    closeButtonLabel: PropTypes.string.isRequired,
    onOk: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired
}

export default reduxForm({ form: "FulfillOrderDialog" })(FulfillOrderDialog);



// WEBPACK FOOTER //
// app/components/dashboard/FulfillOrderDialog.jsx